import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import MapChart from "./map";

const MapContainer = () => {
  const [userData, setUserData] = useState([]);
  const baseURL = 
  process.env.NODE_ENV === 'production' 
    ? process.env.REACT_APP_API_URL_PROD 
    : process.env.REACT_APP_API_URL_LOCAL;

  const fetchUsers = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      console.error("No token found. User is not authenticated.");
      return;
    }

    const apiUrl = `${baseURL}/api/user`;
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

     if (!response.ok && response.status >= 500) {
        throw new Error(`Server error (${response.status})`);
      }

      // Silently return if it's 204 or 404 (no content / not found)
      if (response.status === 204 || response.status === 404) {
        console.log(`No user data found (Status: ${response.status})`);
        return;
      }

      const data = await response.json();

      if (!data || typeof data !== "object") {
        console.log("Invalid data format received");
        return;
      }

if (data.details && Array.isArray(data.details)) {
  const mapped = data.details
    .filter(d => d.lat && d.lng && !isNaN(d.lat) && !isNaN(d.lng))
    .map(d => ({
      ...d,
      lat: parseFloat(d.lat),
      lng: parseFloat(d.lng),
      population: parseInt(d.population || "10"),
      date: d.date || "Unknown",
      city: d.city || "Unknown",
    }));
  setUserData(mapped);
} else {
  console.error("details is missing or not an array");
}

      
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Internal Server Error",
        text: error.message || "Error fetching user details",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div>
      <MapChart data={userData} />
    </div>
  );
};

export default MapContainer;
